// Bump these whenever the wording of the Terms of Service or Privacy Policy
// changes. Existing users will be forced to re-accept on next page load.
// Keep TERMS_VERSION in sync with aws/lambda/_terms.js.
export const TERMS_VERSION = "2026-05-19";
export const TERMS_LAST_UPDATED_DISPLAY = "19 May 2026";
